module.exports = __webpack_public_path__ + "static/piggy-ca374e2489f99ec2127af2fd3479b866.jpg";